import { Headphones } from 'phosphor-react';
import React, { useEffect, useState } from 'react';
import { useMainTheme } from 'state/sounds/hooks';
import { randomFloat } from 'utils/math';

import * as S from './SoundPlayer.styles';

const SoundPlayer: React.FC<{ startPlaying: boolean }> = ({ startPlaying }) => {
  const [triggeredPlay, setTriggeredPlay] = useState(false);

  const { play, pause, isPlaying } = useMainTheme();

  useEffect(() => {
    if (!triggeredPlay && startPlaying && !isPlaying) {
      setTriggeredPlay(true);
      play();
    }
  }, [play, isPlaying, startPlaying, triggeredPlay]);

  return (
    <S.SoundPlayerWrapper>
      <S.PlayPauseButtonWrapper onClick={() => (!isPlaying ? play() : pause())}>
        <S.PlayPauseImg playing={isPlaying}></S.PlayPauseImg>
      </S.PlayPauseButtonWrapper>
      <S.AudioTitleWrapper>
        <S.AudioTitle>Start the journey</S.AudioTitle>
        <S.AudioSubTitle>
          <Headphones size={16} />
          Best with headphones
        </S.AudioSubTitle>
      </S.AudioTitleWrapper>
      <S.AudioWaves>
        <S.AudioWave sizeMax={20} isPlaying={isPlaying} animationTime={randomFloat(1.5, 2.5, 2)} />
        <S.AudioWave sizeMax={35} isPlaying={isPlaying} animationTime={randomFloat(1.5, 2.5, 2)} />
        <S.AudioWave sizeMax={45} isPlaying={isPlaying} animationTime={randomFloat(1, 2, 2)} />
        <S.AudioWave sizeMax={45} isPlaying={isPlaying} animationTime={randomFloat(1, 2, 2)} />
        <S.AudioWave sizeMax={35} isPlaying={isPlaying} animationTime={randomFloat(1.5, 2.5, 2)} />
        <S.AudioWave sizeMax={20} isPlaying={isPlaying} animationTime={randomFloat(1.5, 2.5, 2)} />
      </S.AudioWaves>
    </S.SoundPlayerWrapper>
  );
};

export default SoundPlayer;
